import { StyleSheet, View } from 'react-native';
import { Divider, Text } from 'react-native-paper';

import { AppBottomSheet, SelectOptionRow } from '@/components/atoms';
import { useTranslation } from '@/i18n';
import {
  HANDOFF_DATE_RANGES,
  HANDOFF_DATE_RANGE_TRANSLATION_KEYS,
  type HandoffDateRange,
} from '@/models/handoffDateRange';
import { spacing } from '@/theme';

const SHEET_SNAP_POINTS = ['55%'] as const;

interface DateRangeFilterSheetProps {
  readonly visible: boolean;
  readonly title: string;
  readonly selectedRange: HandoffDateRange;
  readonly unreadRanges?: readonly HandoffDateRange[];
  readonly onSelect: (range: HandoffDateRange) => void;
  readonly onDismiss: () => void;
}

export const DateRangeFilterSheet = ({
  visible,
  title,
  selectedRange,
  unreadRanges = [],
  onSelect,
  onDismiss,
}: DateRangeFilterSheetProps) => {
  const { t } = useTranslation();

  return (
    <AppBottomSheet visible={visible} snapPoints={[...SHEET_SNAP_POINTS]} onDismiss={onDismiss}>
      <View style={styles.header}>
        <Text variant="titleLarge">{title}</Text>
      </View>
      <Divider />
      {HANDOFF_DATE_RANGES.map((range, index) => (
        <SelectOptionRow
          key={range}
          label={t(HANDOFF_DATE_RANGE_TRANSLATION_KEYS[range])}
          selected={range === selectedRange}
          showDivider={index < HANDOFF_DATE_RANGES.length - 1}
          showIndicator={unreadRanges.includes(range)}
          indicatorPosition="trailing"
          indicatorSize={9}
          testID={`date-range-filter-sheet-item-${range}`}
          onPress={() => onSelect(range)}
        />
      ))}
    </AppBottomSheet>
  );
};

const styles = StyleSheet.create({
  header: {
    alignItems: 'center',
    paddingVertical: spacing[2],
  },
});
